import { AddXLevels } from '../utils/AddXLevel';
import { pipelineData } from './dummyPipeline';

export const demoChat = [
  {
    content:
      'Load customer CSV from this path s3://dep-qa/inputs/Customer_1.csv, join with ticket data present at this path s3://dep-qa/inputs/support_tickets_updated.csv, keep only Indian customers, store in table called customer_360 in postgressql database: dep_Aws and schema is public.',
    type: 'text',
    sender: 'user',
    timestamp: '2025-07-08T13:13:50.280500',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:50.280766',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:50.821449',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:51.283246',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:51.784022',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:52.284772',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:52.828228',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:53.285622',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:53.786309',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:54.286738',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:54.787397',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:55.287979',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:55.788600',
  },
  {
    content:
      "Adding source: {'name': 'customer_data', 'type': 's3', 'config': {'path': 's3://dep-qa/inputs/Customer_1.csv', 'format': 'csv'}}",
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:55.788793',
  },
  {
    content:
      "Adding source: {'name': 'ticket_data', 'type': 's3', 'config': {'path': 's3://dep-qa/inputs/support_tickets_updated.csv', 'format': 'csv'}}",
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:55.788953',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:56.288944',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:56.815758',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:57.291247',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:57.793035',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:58.294530',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:58.796233',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:59.297357',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:13:59.798285',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:00.298916',
  },
  {
    content: 'Profiling sources and destination using Sherlock - The Data Detective',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:00.299123',
  },
  {
    content: '✅ Sherlock - The Data Detective initialized successfully',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:00.299329',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:00.799740',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:01.300487',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:01.801344',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:02.302552',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:02.803518',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:03.305331',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:03.807274',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:04.309168',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:04.811072',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:05.312908',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:05.814512',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:06.316383',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:06.818160',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:07.319982',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:07.821985',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:08.323752',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:08.825823',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:09.327691',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:09.829522',
  },
  {
    content: "Sherlock Data Detective's Findings",
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:09.829771',
  },
  {
    content:
      '{\n  "sources": [\n    {\n      "source_id": "customer_data",\n      "source_type": "s3",\n      "format": "csv",\n      "path": "s3://dep-qa/inputs/Customer_1.csv",\n      "connection_info": {\n        "host": "",\n        "database": "",\n        "table": ""\n      },\n      "columns": [\n        {\n          "name": "customer_id",\n          "data_type": "string",\n          "nullable": false,\n          "constraints": []\n        },\n        {\n          "name": "name",\n          "data_type": "string",\n          "nullable": true,\n          "constraints": []\n        },\n        {\n          "name": "country",\n          "data_type": "string",\n          "nullable": true,\n          "constraints": []\n        },\n        {\n          "name": "phone",\n          "data_type": "string",\n          "nullable": true,\n          "constraints": []\n        },\n        {\n          "name": "email",\n          "data_type": "string",\n          "nullable": true,\n          "constraints": []\n        }\n      ]\n    },\n    {\n      "source_id": "ticket_data",\n      "source_type": "s3",\n      "format": "csv",\n      "path": "s3://dep-qa/inputs/support_tickets_updated.csv",\n      "connection_info": {\n        "host": "",\n        "database": "",\n        "table": ""\n      },\n      "columns": [\n        {\n          "name": "ticket_id",\n          "data_type": "string",\n          "nullable": false,\n          "constraints": []\n        },\n        {\n          "name": "customer_id",\n          "data_type": "string",\n          "nullable": false,\n          "constraints": []\n        },\n        {\n          "name": "issue",\n          "data_type": "string",\n          "nullable": true,\n          "constraints": []\n        },\n        {\n          "name": "timestamp",\n          "data_type": "string",\n          "nullable": true,\n          "constraints": []\n        },\n        {\n          "name": "status",\n          "data_type": "string",\n          "nullable": true,\n          "constraints": []\n        }\n      ]\n    }\n  ],\n  "destinations": [\n    {\n      "destination_id": "customer_360",\n      "destination_type": "postgres",\n      "format": "postgres",\n      "path": "",\n      "connection_info": {\n        "host": "",\n        "database": "dep_Aws",\n        "table": "customer_360"\n      },\n      "schema": {\n        "columns": [\n          {\n            "name": "customer_id",\n            "data_type": "character varying",\n            "nullable": false,\n            "constraints": []\n          },\n          {\n            "name": "name",\n            "data_type": "character varying",\n            "nullable": true,\n            "constraints": []\n          },\n          {\n            "name": "country",\n            "data_type": "character varying",\n            "nullable": true,\n            "constraints": []\n          },\n          {\n            "name": "phone",\n            "data_type": "character varying",\n            "nullable": true,\n            "constraints": []\n          },\n          {\n            "name": "last_issue",\n            "data_type": "character varying",\n            "nullable": true,\n            "constraints": []\n          },\n          {\n            "name": "last_interaction_date",\n            "data_type": "date",\n            "nullable": true,\n            "constraints": []\n          }\n        ]\n      }\n    }\n  ]\n}',
    type: 'PLAN',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:09.829956',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:10.331430',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:10.833290',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:11.335189',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:11.837112',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:12.338785',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:12.840577',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:13.342448',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:13.844217',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:14.345949',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:14.848020',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:15.350459',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:15.851158',
  },
  {
    content: 'Running Picasso - The ETL Architect',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:15.851413',
  },
  {
    content: '✅ Picasso - The ETL Architect initialized successfully',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:15.851542',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:16.352071',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:16.853125',
  },
  {
    content: 'Connecting to Database',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:16.853328',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:17.354117',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:17.855012',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:18.355485',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:18.856569',
  },
  {
    content: " Picasso's Architecture Plan",
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:18.856786',
  },
  {
    content:
      '[\n    {\n        "block_name": "ReadCSV",\n        "description": "Read data from CSV files"\n    },\n    {\n        "block_name": "ReadCSVaws",\n        "description": "Read csv data from aws"\n    },\n    {\n        "block_name": "Join",\n        "description": "Join two or more tables"\n    },\n    {\n        "block_name": "Filter",\n        "description": "Filter rows based on conditions"\n    },\n    {\n        "block_name": "WriteCSV",\n        "description": "Write data to CSV files"\n    }\n]',
    type: 'PLAN',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:18.857023',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:19.357178',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:21.318113',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:21.819466',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:22.320939',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:22.822309',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:23.323720',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:23.825167',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:24.326542',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:24.828000',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:25.329516',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:25.831185',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:26.332770',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:26.834391',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:27.335980',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:27.837432',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:28.338996',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:28.840557',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:29.342089',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:29.843699',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:30.345232',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:30.846775',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:31.348362',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:31.849957',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:32.351557',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:32.853181',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:33.354789',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:33.856336',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:34.357958',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:34.859585',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:35.361184',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:35.862915',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:36.364470',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:36.866018',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:37.367475',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:37.869156',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:38.370725',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:38.872327',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:39.373874',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:39.875487',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:40.377100',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:40.878837',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:41.380171',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:41.881795',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:42.383373',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:42.884976',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:43.386453',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:43.888050',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:44.389575',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:44.891198',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:45.392792',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:45.894462',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:46.396066',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:46.897800',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:47.399330',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:47.900992',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:48.402477',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:48.904125',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:49.405688',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:49.907260',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:50.408828',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:50.910353',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:51.411915',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:53.319676',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:53.820146',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:54.322420',
  },
  {
    content: 'Running Virtuoso - The ETL Composer',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:54.322618',
  },
  {
    content: 'Initializing Virtuoso - The ETL Composer...',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:54.322796',
  },
  {
    content: '✅ Virtuoso - The ETL Composer initialized successfully.\n',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:54.322955',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:54.824390',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:55.326127',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:55.827913',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:56.329644',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:56.831495',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:57.333530',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:57.835571',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:58.337550',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:58.840093',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:59.341633',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:14:59.843609',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:00.345688',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:00.847608',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:01.349630',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:01.851670',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:02.353700',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:02.855544',
  },
  {
    content: 'Connecting to Database',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:02.855738',
  },
  {
    content: 'Connecting to Database',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:02.855920',
  },
  {
    content: 'Connecting to Database',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:02.856026',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:03.356574',
  },
  {
    content: 'Connecting to Database',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:03.356780',
  },
  {
    content: 'Connecting to Database',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:03.356982',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:03.857442',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:04.358072',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:04.859653',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:05.361265',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:05.862990',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:06.364546',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:06.866224',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:07.367966',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:07.869473',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:08.370991',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:08.872613',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:09.374381',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:09.876323',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:10.378003',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:10.880015',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:11.382089',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:11.883841',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:12.385472',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:12.887062',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:13.388696',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:13.890292',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:14.391939',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:14.893535',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:15.395061',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:15.896725',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:16.398365',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:16.900183',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:17.401796',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:17.903613',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:18.405256',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:18.907034',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:19.408571',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:19.910173',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:20.411501',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:20.913055',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:21.414542',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:21.916160',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:22.417675',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:22.919079',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:23.420593',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:25.320540',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:25.822017',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:26.323520',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:26.825404',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:27.326975',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:27.828620',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:28.330349',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:28.832055',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:29.333782',
  },
  {
    content: 'Agent is Thinking',
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:29.834502',
  },
  {
    content: "Virtuoso ETL Composer's Plan",
    type: 'INFO',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:29.834710',
  },
  {
    content:
      '[\n    {\n        "step_no": 1,\n        "formData": {\n            "formField": {\n                "path": "s3://dep-qa/inputs/Customer_1.csv",\n                "alias": "customer_data",\n                "format": "csv",\n                "delimiter": ",",\n                "sample_view": true,\n                "dataTypeRead": "refernce",\n                "pathTypeFile": "filepath"\n            },\n            "headerName": [\n                {\n                    "header": "customer_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "name",\n                    "checked": "true"\n                },\n                {\n                    "header": "country",\n                    "checked": "true"\n                },\n                {\n                    "header": "phone",\n                    "checked": "true"\n                },\n                {\n                    "header": "email",\n                    "checked": "true"\n                }\n            ]\n        },\n        "currentNode": {\n            "nodeId": "dndnode_1751980014462",\n            "nodeName": "ReadCSV"\n        },\n        "previousNodes": []\n    },\n    {\n        "step_no": 2,\n        "formData": {\n            "formField": {\n                "path": "s3://dep-qa/inputs/support_tickets_updated.csv",\n                "alias": "ticket_data",\n                "format": "csv",\n                "delimiter": ",",\n                "sample_view": true,\n                "dataTypeRead": "reference",\n                "pathTypeFile": "filepath",\n                "connection_type": "default"\n            },\n            "headerName": [\n                {\n                    "header": "ticket_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "customer_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "issue",\n                    "checked": "true"\n                },\n                {\n                    "header": "timestamp",\n                    "checked": "true"\n                },\n                {\n                    "header": "status",\n                    "checked": "true"\n                }\n            ]\n        },\n        "currentNode": {\n            "nodeId": "dndnode_1751980016503",\n            "nodeName": "ReadCSVAws"\n        },\n        "previousNodes": []\n    },\n    {\n        "step_no": 3,\n        "formData": {\n            "count": {\n                "count_1": 1,\n                "count_2": 1\n            },\n            "onRow": [\n                {\n                    "row": "row1",\n                    "count": "count_1",\n                    "table1": "customer_data.customer_id",\n                    "table2": "ticket_data.customer_id"\n                }\n            ],\n            "formField": {\n                "alias": "joined_data",\n                "joins": {\n                    "join1": "inner"\n                },\n                "tables": {\n                    "table1": "customer_data",\n                    "table2": "ticket_data"\n                },\n                "select_cols": "",\n                "join_conditions": "customer_data.customer_id = ticket_data.customer_id"\n            },\n            "headerName": [\n                {\n                    "header": "customer_data.customer_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "customer_data.name",\n                    "checked": "true"\n                },\n                {\n                    "header": "customer_data.country",\n                    "checked": "true"\n                },\n                {\n                    "header": "customer_data.phone",\n                    "checked": "true"\n                },\n                {\n                    "header": "customer_data.email",\n                    "checked": "true"\n                },\n                {\n                    "header": "ticket_data.ticket_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "ticket_data.issue",\n                    "checked": "true"\n                },\n                {\n                    "header": "ticket_data.timestamp",\n                    "checked": "true"\n                },\n                {\n                    "header": "ticket_data.status",\n                    "checked": "true"\n                }\n            ]\n        },\n        "currentNode": {\n            "nodeId": "dndnode_1751980015477",\n            "nodeName": "Join"\n        },\n        "previousNodes": [\n            {\n                "nodeId": "dndnode_1751980014462",\n                "nodeName": "ReadCSV"\n            },\n            {\n                "nodeId": "dndnode_1751980016503",\n                "nodeName": "ReadCSVaws"\n            }\n        ]\n    },\n    {\n        "step_no": 4,\n        "formData": {\n            "sorting": [\n                {\n                    "oper": "=",\n                    "clause": "AND",\n                    "filter": "India",\n                    "header": "country",\n                    "condition": "Condition_Group_1"\n                }\n            ],\n            "addClause": [\n                {\n                    "count": "1",\n                    "clause": "AND",\n                    "condition": "Condition_Group_1"\n                }\n            ],\n            "formField": {\n                "df": "joined_data",\n                "alias": "filtered_data",\n                "statement": "country = \'India\'"\n            },\n            "attributes": [\n                "Condition_Group_1"\n            ],\n            "headerName": [\n                {\n                    "header": "customer_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "name",\n                    "checked": "true"\n                },\n                {\n                    "header": "country",\n                    "checked": "true"\n                },\n                {\n                    "header": "phone",\n                    "checked": "true"\n                },\n                {\n                    "header": "email",\n                    "checked": "true"\n                },\n                {\n                    "header": "ticket_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "issue",\n                    "checked": "true"\n                },\n                {\n                    "header": "timestamp",\n                    "checked": "true"\n                },\n                {\n                    "header": "status",\n                    "checked": "true"\n                }\n            ]\n        },\n        "currentNode": {\n            "nodeId": "dndnode_1751980017524",\n            "nodeName": "Filter"\n        },\n        "previousNodes": [\n            {\n                "nodeId": "dndnode_1751980015477",\n                "nodeName": "Join"\n            }\n        ]\n    },\n    {\n        "step_no": 5,\n        "formData": {\n            "formField": {\n                "mode": "overwrite",\n                "path": "dep-qa/Internal/POC/Copilot Json Test/Output/WriteCsvAWS_1750668414647",\n                "alias": "Customer_360",\n                "format": "csv"\n            },\n            "headerName": [\n                {\n                    "header": "customer_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "name",\n                    "checked": "true"\n                },\n                {\n                    "header": "country",\n                    "checked": "true"\n                },\n                {\n                    "header": "phone",\n                    "checked": "true"\n                },\n                {\n                    "header": "email",\n                    "checked": "true"\n                },\n                {\n                    "header": "ticket_id",\n                    "checked": "true"\n                },\n                {\n                    "header": "issue",\n                    "checked": "true"\n                },\n                {\n                    "header": "timestamp",\n                    "checked": "true"\n                },\n                {\n                    "header": "status",\n                    "checked": "true"\n                }\n            ]\n        },\n        "currentNode": {\n            "nodeId": "dndnode_1751980018543",\n            "nodeName": "WriteCSV"\n        },\n        "previousNodes": [\n            {\n                "nodeId": "dndnode_1751980017524",\n                "nodeName": "Filter"\n            }\n        ]\n    }\n]',
    type: 'PLAN',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:29.834952',
  },
  {
    content: AddXLevels(pipelineData),
    type: 'Pipeline',
    sender: 'copilot',
    timestamp: '2025-07-08T13:15:57.639750',
  },
];
